// Comprehensive stub/mock data for demo purposes
// Based on the proposal document entities

// Membership Types
export const membershipTypes = [
  {
    id: 1,
    name: 'Individual',
    allowsMultipleMembers: false,
    minMembers: 1,
    maxMembers: 1,
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 2,
    name: 'Joint',
    allowsMultipleMembers: true,
    minMembers: 2,
    maxMembers: 2,
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 4,
    name: 'Youth',
    allowsMultipleMembers: false,
    minMembers: 1,
    maxMembers: 1,
    createdAt: '2023-01-01T00:00:00Z',
  },
];

// Yearly Prices
export const yearlyPrices = [
  {
    id: 1,
    membershipTypeId: 1,
    year: 2024,
    basePrice: 45.0,
    effectiveFrom: '2024-01-01',
    effectiveTo: '2024-12-31',
  },
  {
    id: 2,
    membershipTypeId: 2,
    year: 2024,
    basePrice: 75.0,
    effectiveFrom: '2024-01-01',
    effectiveTo: '2024-12-31',
  },
  {
    id: 4,
    membershipTypeId: 4,
    year: 2024,
    basePrice: 20.0,
    effectiveFrom: '2024-01-01',
    effectiveTo: '2024-12-31',
  },
  {
    id: 6,
    membershipTypeId: 1,
    year: 2025,
    basePrice: 48.0,
    effectiveFrom: '2025-01-01',
    effectiveTo: '2025-12-31',
  },
  {
    id: 7,
    membershipTypeId: 2,
    year: 2025,
    basePrice: 78.0,
    effectiveFrom: '2025-01-01',
    effectiveTo: '2025-12-31',
  },
  {
    id: 9,
    membershipTypeId: 4,
    year: 2025,
    basePrice: 22.0,
    effectiveFrom: '2025-01-01',
    effectiveTo: '2025-12-31',
  },
];

// Addresses
export const addresses = [
  {
    id: 1,
    line1: '15 Oak Avenue',
    line2: '',
    line3: '',
    town: 'Reading',
    county: 'Berkshire',
    postcode: 'RG1 5NP',
  },
  {
    id: 2,
    line1: '42 Elm Street',
    line2: '',
    line3: '',
    town: 'Manchester',
    county: 'Greater Manchester',
    postcode: 'M1 2WD',
  },
  {
    id: 3,
    line1: '7 Birch Lane',
    line2: 'Flat 3',
    line3: '',
    town: 'Bristol',
    county: 'Bristol',
    postcode: 'BS1 3AG',
  },
  {
    id: 4,
    line1: '128 Pine Road',
    line2: '',
    line3: '',
    town: 'Birmingham',
    county: 'West Midlands',
    postcode: 'B2 4QA',
  },
  {
    id: 5,
    line1: '56 Maple Drive',
    line2: '',
    line3: '',
    town: 'Leeds',
    county: 'West Yorkshire',
    postcode: 'LS1 4BU',
  },
  {
    id: 6,
    line1: '23 Cedar Close',
    line2: '',
    line3: '',
    town: 'Liverpool',
    county: 'Merseyside',
    postcode: 'L1 8JQ',
  },
  {
    id: 7,
    line1: '91 Ash Court',
    line2: 'Apartment 12',
    line3: '',
    town: 'Newcastle',
    county: 'Tyne and Wear',
    postcode: 'NE1 4XE',
  },
  {
    id: 8,
    line1: '34 Willow Way',
    line2: '',
    line3: '',
    town: 'Sheffield',
    county: 'South Yorkshire',
    postcode: 'S1 2GF',
  },
  {
    id: 9,
    line1: '67 Beech Avenue',
    line2: '',
    line3: '',
    town: 'Nottingham',
    county: 'Nottinghamshire',
    postcode: 'NG1 6DQ',
  },
  {
    id: 10,
    line1: '12 Sycamore Street',
    line2: '',
    line3: '',
    town: 'Leicester',
    county: 'Leicestershire',
    postcode: 'LE1 5WL',
  },
];

// Active Members
export const members = [
  {
    membershipNumber: 'HDL001',
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'Robert',
    lastName: 'Wilson',
    dob: '1975-05-15',
    telephone: '0118 123 4567',
    mobile: '07700 900001',
    email: 'robert.wilson@example.com',
    privacyNoticeAccepted: '2023-01-15T10:30:00Z',
    createdAt: '2023-01-15T10:30:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-01-15',
  },
  {
    membershipNumber: 'HDL002',
    addressId: 2,
    membershipTypeId: 1,
    firstName: 'Alice',
    lastName: 'Cooper',
    dob: '1980-03-22',
    telephone: '0161 234 5678',
    mobile: '07700 900002',
    email: 'alice.cooper@example.com',
    privacyNoticeAccepted: '2023-02-20T14:15:00Z',
    createdAt: '2023-02-20T14:15:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-02-20',
  },
  {
    membershipNumber: 'HDL003',
    addressId: 3,
    membershipTypeId: 1,
    firstName: 'Thomas',
    lastName: 'Harris',
    dob: '1968-11-08',
    telephone: '0117 345 6789',
    mobile: '07700 900003',
    email: 'thomas.harris@example.com',
    privacyNoticeAccepted: '2023-03-10T09:45:00Z',
    createdAt: '2023-03-10T09:45:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-03-10',
  },
  {
    membershipNumber: 'HDL004',
    addressId: 4,
    membershipTypeId: 4,
    firstName: 'Patricia',
    lastName: 'Murphy',
    dob: '2008-07-12',
    telephone: '0121 456 7890',
    mobile: '07700 900004',
    email: 'patricia.murphy@example.com',
    privacyNoticeAccepted: '2023-04-05T16:20:00Z',
    createdAt: '2023-04-05T16:20:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-04-05',
  },
  {
    membershipNumber: 'HDL005',
    addressId: 5,
    membershipTypeId: 1,
    firstName: 'George',
    lastName: 'Baker',
    dob: '1972-09-30',
    telephone: '0113 567 8901',
    mobile: '07700 900005',
    email: 'george.baker@example.com',
    privacyNoticeAccepted: '2023-05-15T11:00:00Z',
    createdAt: '2023-05-15T11:00:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-05-15',
  },
  {
    membershipNumber: 'HDL006',
    addressId: 6,
    membershipTypeId: 1,
    firstName: 'Helen',
    lastName: 'Foster',
    dob: '1985-02-14',
    telephone: '0151 678 9012',
    mobile: '07700 900006',
    email: 'helen.foster@example.com',
    privacyNoticeAccepted: '2023-06-20T13:30:00Z',
    createdAt: '2023-06-20T13:30:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-06-20',
  },
  {
    membershipNumber: 'HDL007',
    addressId: 7,
    membershipTypeId: 1,
    firstName: 'Richard',
    lastName: 'Edwards',
    dob: '1978-12-25',
    telephone: '0191 789 0123',
    mobile: '07700 900007',
    email: 'richard.edwards@example.com',
    privacyNoticeAccepted: '2023-07-01T08:15:00Z',
    createdAt: '2023-07-01T08:15:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-07-01',
  },
  {
    membershipNumber: 'HDL008',
    addressId: 8,
    membershipTypeId: 4,
    firstName: 'Margaret',
    lastName: 'Phillips',
    dob: '2009-04-18',
    telephone: '0114 890 1234',
    mobile: '07700 900008',
    email: 'margaret.phillips@example.com',
    privacyNoticeAccepted: '2023-08-12T15:45:00Z',
    createdAt: '2023-08-12T15:45:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-08-12',
  },
  {
    membershipNumber: 'HDL009',
    addressId: 9,
    membershipTypeId: 2,
    firstName: 'Peter',
    lastName: 'Morgan',
    dob: '1965-06-05',
    telephone: '0115 901 2345',
    mobile: '07700 900009',
    email: 'peter.morgan@example.com',
    privacyNoticeAccepted: '2024-01-01T10:00:00Z',
    createdAt: '2024-01-01T10:00:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-15', // Soon to expire
  },
  {
    membershipNumber: 'HDL010',
    addressId: 10,
    membershipTypeId: 1,
    firstName: 'Laura',
    lastName: 'Bennett',
    dob: '1990-10-20',
    telephone: '0116 012 3456',
    mobile: '07700 900010',
    email: 'laura.bennett@example.com',
    privacyNoticeAccepted: '2024-01-05T12:30:00Z',
    createdAt: '2024-01-05T12:30:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-20', // Soon to expire
  },
  {
    membershipNumber: 'HDL011',
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'Kevin',
    lastName: 'Hughes',
    dob: '1982-01-28',
    telephone: '0118 123 9999',
    mobile: '07700 900011',
    email: 'kevin.hughes@example.com',
    privacyNoticeAccepted: '2024-02-10T09:15:00Z',
    createdAt: '2024-02-10T09:15:00Z',
    isManual: true,
    status: 'expired',
    renewalDate: '2024-11-10', // Expired
  },
  // Additional Reading members (high concentration)
  {
    membershipNumber: 'HDL012',
    addressId: 1,
    membershipTypeId: 2,
    firstName: 'Sarah',
    lastName: 'Mitchell',
    dob: '1988-04-12',
    telephone: '0118 456 7890',
    mobile: '07700 900012',
    email: 'sarah.mitchell@example.com',
    privacyNoticeAccepted: '2024-03-15T14:20:00Z',
    createdAt: '2024-03-15T14:20:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-03-15',
  },
  {
    membershipNumber: 'HDL013',
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'James',
    lastName: 'Turner',
    dob: '1976-08-30',
    telephone: '0118 789 0123',
    mobile: '07700 900013',
    email: 'james.turner@example.com',
    privacyNoticeAccepted: '2024-04-20T09:30:00Z',
    createdAt: '2024-04-20T09:30:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-04-20',
  },
  {
    membershipNumber: 'HDL014',
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'Emma',
    lastName: 'Davies',
    dob: '1992-11-18',
    telephone: '0118 234 5678',
    mobile: '07700 900014',
    email: 'emma.davies@example.com',
    privacyNoticeAccepted: '2024-05-10T11:45:00Z',
    createdAt: '2024-05-10T11:45:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-05-10',
  },
  {
    membershipNumber: 'HDL015',
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'Oliver',
    lastName: 'Thompson',
    dob: '1984-02-25',
    telephone: '0118 567 8901',
    mobile: '07700 900015',
    email: 'oliver.thompson@example.com',
    privacyNoticeAccepted: '2024-06-05T16:00:00Z',
    createdAt: '2024-06-05T16:00:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-06-05',
  },
  // Additional Manchester members (high concentration)
  {
    membershipNumber: 'HDL016',
    addressId: 2,
    membershipTypeId: 1,
    firstName: 'Sophie',
    lastName: 'Anderson',
    dob: '1990-07-14',
    telephone: '0161 345 6789',
    mobile: '07700 900016',
    email: 'sophie.anderson@example.com',
    privacyNoticeAccepted: '2024-07-12T10:15:00Z',
    createdAt: '2024-07-12T10:15:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-07-12',
  },
  {
    membershipNumber: 'HDL017',
    addressId: 2,
    membershipTypeId: 2,
    firstName: 'William',
    lastName: 'Roberts',
    dob: '1979-09-03',
    telephone: '0161 678 9012',
    mobile: '07700 900017',
    email: 'william.roberts@example.com',
    privacyNoticeAccepted: '2024-08-22T13:40:00Z',
    createdAt: '2024-08-22T13:40:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-08-22',
  },
  {
    membershipNumber: 'HDL018',
    addressId: 2,
    membershipTypeId: 1,
    firstName: 'Charlotte',
    lastName: 'Evans',
    dob: '1987-12-08',
    telephone: '0161 901 2345',
    mobile: '07700 900018',
    email: 'charlotte.evans@example.com',
    privacyNoticeAccepted: '2024-09-15T15:25:00Z',
    createdAt: '2024-09-15T15:25:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-09-15',
  },
  // Additional Birmingham members (medium concentration)
  {
    membershipNumber: 'HDL019',
    addressId: 4,
    membershipTypeId: 1,
    firstName: 'Daniel',
    lastName: 'Jackson',
    dob: '1983-05-20',
    telephone: '0121 234 5678',
    mobile: '07700 900019',
    email: 'daniel.jackson@example.com',
    privacyNoticeAccepted: '2024-10-01T09:50:00Z',
    createdAt: '2024-10-01T09:50:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-10-01',
  },
  {
    membershipNumber: 'HDL020',
    addressId: 4,
    membershipTypeId: 1,
    firstName: 'Emily',
    lastName: 'White',
    dob: '1991-03-17',
    telephone: '0121 567 8901',
    mobile: '07700 900020',
    email: 'emily.white@example.com',
    privacyNoticeAccepted: '2024-10-15T12:10:00Z',
    createdAt: '2024-10-15T12:10:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-10-15',
  },
  // Additional Leeds members (medium concentration)
  {
    membershipNumber: 'HDL021',
    addressId: 5,
    membershipTypeId: 1,
    firstName: 'Benjamin',
    lastName: 'Clark',
    dob: '1986-01-09',
    telephone: '0113 678 9012',
    mobile: '07700 900021',
    email: 'benjamin.clark@example.com',
    privacyNoticeAccepted: '2024-11-02T14:35:00Z',
    createdAt: '2024-11-02T14:35:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-11-02',
  },
  {
    membershipNumber: 'HDL022',
    addressId: 5,
    membershipTypeId: 2,
    firstName: 'Jessica',
    lastName: 'Lewis',
    dob: '1989-06-22',
    telephone: '0113 789 0123',
    mobile: '07700 900022',
    email: 'jessica.lewis@example.com',
    privacyNoticeAccepted: '2024-11-18T16:20:00Z',
    createdAt: '2024-11-18T16:20:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-11-18',
  },
  // Additional Bristol members (medium-low concentration)
  {
    membershipNumber: 'HDL023',
    addressId: 3,
    membershipTypeId: 1,
    firstName: 'Alexander',
    lastName: 'Walker',
    dob: '1981-10-15',
    telephone: '0117 456 7890',
    mobile: '07700 900023',
    email: 'alexander.walker@example.com',
    privacyNoticeAccepted: '2024-12-01T10:00:00Z',
    createdAt: '2024-12-01T10:00:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-01',
  },
  // Additional Liverpool members (medium-low concentration)
  {
    membershipNumber: 'HDL024',
    addressId: 6,
    membershipTypeId: 1,
    firstName: 'Olivia',
    lastName: 'Hall',
    dob: '1993-08-07',
    telephone: '0151 789 0123',
    mobile: '07700 900024',
    email: 'olivia.hall@example.com',
    privacyNoticeAccepted: '2024-12-10T11:30:00Z',
    createdAt: '2024-12-10T11:30:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-10',
  },
  // Additional Sheffield members (low concentration)
  {
    membershipNumber: 'HDL025',
    addressId: 8,
    membershipTypeId: 1,
    firstName: 'Jacob',
    lastName: 'Allen',
    dob: '1985-04-28',
    telephone: '0114 901 2345',
    mobile: '07700 900025',
    email: 'jacob.allen@example.com',
    privacyNoticeAccepted: '2024-12-15T13:45:00Z',
    createdAt: '2024-12-15T13:45:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-15',
  },
  // Additional Nottingham members (low concentration)
  {
    membershipNumber: 'HDL026',
    addressId: 9,
    membershipTypeId: 1,
    firstName: 'Isabella',
    lastName: 'Young',
    dob: '1994-02-11',
    telephone: '0115 012 3456',
    mobile: '07700 900026',
    email: 'isabella.young@example.com',
    privacyNoticeAccepted: '2024-12-20T15:10:00Z',
    createdAt: '2024-12-20T15:10:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-20',
  },
  // Additional Leicester members (low concentration)
  {
    membershipNumber: 'HDL027',
    addressId: 10,
    membershipTypeId: 1,
    firstName: 'Ethan',
    lastName: 'King',
    dob: '1988-11-26',
    telephone: '0116 123 4567',
    mobile: '07700 900027',
    email: 'ethan.king@example.com',
    privacyNoticeAccepted: '2024-12-22T09:25:00Z',
    createdAt: '2024-12-22T09:25:00Z',
    isManual: false,
    status: 'active',
    renewalDate: '2025-12-22',
  },
];

// Membership Requests (Pending applications)
export const membershipRequests = [
  {
    id: 1,
    userId: 101,
    addressId: 1,
    membershipTypeId: 1,
    firstName: 'John',
    lastName: 'Smith',
    dob: '1985-03-15',
    telephone: '0118 555 1234',
    mobile: '07700 111222',
    email: 'john.smith@example.com',
    privacyNoticeAccepted: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    processedAt: null,
    rejectionReason: null,
    processedByUserId: null,
    assignedMembershipNumber: null,
  },
  {
    id: 2,
    userId: 102,
    addressId: 2,
    membershipTypeId: 1,
    firstName: 'Mary',
    lastName: 'Johnson',
    dob: '1978-07-22',
    telephone: '0161 555 5678',
    mobile: '07700 222333',
    email: 'mary.johnson@example.com',
    privacyNoticeAccepted: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    processedAt: null,
    rejectionReason: null,
    processedByUserId: null,
    assignedMembershipNumber: null,
  },
  {
    id: 3,
    userId: 103,
    addressId: 3,
    membershipTypeId: 1,
    firstName: 'David',
    lastName: 'Williams',
    dob: '1992-11-05',
    telephone: '0117 555 9012',
    mobile: '07700 333444',
    email: 'david.williams@example.com',
    privacyNoticeAccepted: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    processedAt: null,
    rejectionReason: null,
    processedByUserId: null,
    assignedMembershipNumber: null,
  },
  {
    id: 4,
    userId: 104,
    addressId: 4,
    membershipTypeId: 4,
    firstName: 'Sarah',
    lastName: 'Brown',
    dob: '2010-05-18',
    telephone: '0121 555 3456',
    mobile: '07700 444555',
    email: 'sarah.brown@example.com',
    privacyNoticeAccepted: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    processedAt: null,
    rejectionReason: null,
    processedByUserId: null,
    assignedMembershipNumber: null,
  },
  {
    id: 5,
    userId: 105,
    addressId: 5,
    membershipTypeId: 1,
    firstName: 'Michael',
    lastName: 'Davis',
    dob: '1988-09-30',
    telephone: '0113 555 7890',
    mobile: '07700 555666',
    email: 'michael.davis@example.com',
    privacyNoticeAccepted: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    processedAt: null,
    rejectionReason: null,
    processedByUserId: null,
    assignedMembershipNumber: null,
  },
];

// Payments
export const payments = [
  {
    id: 1,
    membershipRequestId: null,
    membershipNumber: 'HDL001',
    transactionId: 'pi_1A2B3C4D5E6F',
    amount: 45.0,
    paymentDate: '2023-01-15T10:30:00Z',
    status: 'completed',
    paymentMethod: 'stripe',
    year: 2023,
    isManual: false,
    receiptNumber: 'RCP-2023-001',
    createdAt: '2023-01-15T10:30:00Z',
  },
  {
    id: 2,
    membershipRequestId: null,
    membershipNumber: 'HDL001',
    transactionId: 'pi_2B3C4D5E6F7G',
    amount: 45.0,
    paymentDate: '2024-01-15T10:30:00Z',
    status: 'completed',
    paymentMethod: 'stripe',
    year: 2024,
    isManual: false,
    receiptNumber: 'RCP-2024-015',
    createdAt: '2024-01-15T10:30:00Z',
  },
  {
    id: 3,
    membershipRequestId: null,
    membershipNumber: 'HDL002',
    transactionId: 'pi_3C4D5E6F7G8H',
    amount: 95.0,
    paymentDate: '2023-02-20T14:15:00Z',
    status: 'completed',
    paymentMethod: 'stripe',
    year: 2023,
    isManual: false,
    receiptNumber: 'RCP-2023-002',
    createdAt: '2023-02-20T14:15:00Z',
  },
  {
    id: 4,
    membershipRequestId: null,
    membershipNumber: 'HDL003',
    transactionId: 'MANUAL-001',
    amount: 45.0,
    paymentDate: '2023-03-10T09:45:00Z',
    status: 'completed',
    paymentMethod: 'bank_transfer',
    year: 2023,
    isManual: true,
    receiptNumber: 'RCP-2023-003',
    createdAt: '2023-03-10T09:45:00Z',
  },
  {
    id: 5,
    membershipRequestId: 1,
    membershipNumber: null,
    transactionId: 'pi_4D5E6F7G8H9I',
    amount: 48.0,
    paymentDate: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    status: 'pending',
    paymentMethod: 'stripe',
    year: 2025,
    isManual: false,
    receiptNumber: null,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 6,
    membershipRequestId: null,
    membershipNumber: 'HDL001',
    transactionId: 'pi_5E6F7G8H9I0J',
    amount: 48.0,
    paymentDate: '2025-01-15T10:30:00Z',
    status: 'completed',
    paymentMethod: 'stripe',
    year: 2025,
    isManual: false,
    receiptNumber: 'RCP-2025-001',
    createdAt: '2025-01-15T10:30:00Z',
  },
];

// Email Templates
export const emailTemplates = [
  {
    id: 1,
    name: 'Welcome Email',
    subject: 'Welcome to the Club',
    body: '<p>Dear {{firstName}},</p><p>Welcome to our club! Your membership number is {{membershipNumber}}.</p><p>Best regards,<br>The Team</p>',
    variables: ['firstName', 'lastName', 'membershipNumber'],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 2,
    name: 'Renewal Reminder',
    subject: 'Membership Renewal Due',
    body: '<p>Dear {{firstName}},</p><p>Your membership is due for renewal on {{renewalDate}}. The renewal fee is £{{amount}}.</p><p>Please renew at your earliest convenience.</p>',
    variables: ['firstName', 'renewalDate', 'amount'],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 3,
    name: 'Payment Receipt',
    subject: 'Payment Received',
    body: '<p>Dear {{firstName}},</p><p>We have received your payment of £{{amount}}. Your receipt number is {{receiptNumber}}.</p><p>Thank you!</p>',
    variables: ['firstName', 'amount', 'receiptNumber'],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 4,
    name: 'Application Approved',
    subject: 'Membership Application Approved',
    body: '<p>Dear {{firstName}},</p><p>Congratulations! Your membership application has been approved. Your membership number is {{membershipNumber}}.</p>',
    variables: ['firstName', 'membershipNumber'],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 5,
    name: 'Application Rejected',
    subject: 'Membership Application Status',
    body: '<p>Dear {{firstName}},</p><p>Unfortunately, we are unable to approve your membership application at this time. Reason: {{reason}}</p>',
    variables: ['firstName', 'reason'],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
  },
];

// Email Logs
export const emailLogs = [
  {
    id: 1,
    recipientEmail: 'robert.wilson@example.com',
    templateName: 'Welcome Email',
    subject: 'Welcome to the Club',
    body: '<p>Dear Robert,</p><p>Welcome to our club! Your membership number is HDL001.</p>',
    metadata: { membershipNumber: 'HDL001' },
    status: 'delivered',
    errorMessage: null,
    sentAt: '2023-01-15T10:35:00Z',
    deliveredAt: '2023-01-15T10:35:15Z',
    openedAt: '2023-01-15T12:20:00Z',
    clickedAt: null,
    sendgridMessageId: 'msg_1A2B3C',
    relatedEntityType: 'member',
    relatedEntityId: 1,
    createdAt: '2023-01-15T10:35:00Z',
  },
  {
    id: 2,
    recipientEmail: 'alice.cooper@example.com',
    templateName: 'Welcome Email',
    subject: 'Welcome to the Club',
    body: '<p>Dear Alice,</p><p>Welcome to our club! Your membership number is HDL002.</p>',
    metadata: { membershipNumber: 'HDL002' },
    status: 'delivered',
    errorMessage: null,
    sentAt: '2023-02-20T14:20:00Z',
    deliveredAt: '2023-02-20T14:20:18Z',
    openedAt: '2023-02-20T15:45:00Z',
    clickedAt: '2023-02-20T15:46:30Z',
    sendgridMessageId: 'msg_2B3C4D',
    relatedEntityType: 'member',
    relatedEntityId: 2,
    createdAt: '2023-02-20T14:20:00Z',
  },
  {
    id: 3,
    recipientEmail: 'peter.morgan@example.com',
    templateName: 'Renewal Reminder',
    subject: 'Membership Renewal Due',
    body: '<p>Dear Peter,</p><p>Your membership is due for renewal on 2025-12-15...</p>',
    metadata: { renewalDate: '2025-12-15', amount: '78.00' },
    status: 'delivered',
    errorMessage: null,
    sentAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    deliveredAt: new Date(Date.now() - 24 * 60 * 60 * 1000 + 20000).toISOString(),
    openedAt: null,
    clickedAt: null,
    sendgridMessageId: 'msg_3C4D5E',
    relatedEntityType: 'member',
    relatedEntityId: 9,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 4,
    recipientEmail: 'invalid@bounce.test',
    templateName: 'Welcome Email',
    subject: 'Welcome to the Club',
    body: '<p>Test email</p>',
    metadata: {},
    status: 'bounced',
    errorMessage: 'Mailbox does not exist',
    sentAt: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
    deliveredAt: null,
    openedAt: null,
    clickedAt: null,
    sendgridMessageId: 'msg_4D5E6F',
    relatedEntityType: 'member',
    relatedEntityId: null,
    createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
  },
];

// Audit Logs
export const auditLogs = [
  {
    id: 1,
    entityType: 'member',
    entityId: 1,
    action: 'create',
    oldValues: null,
    newValues: {
      membershipNumber: 'HDL001',
      firstName: 'Robert',
      lastName: 'Wilson',
      status: 'active',
    },
    createdAt: '2023-01-15T10:30:00Z',
    userId: 1,
    ipAddress: '192.168.1.100',
  },
  {
    id: 2,
    entityType: 'payment',
    entityId: 1,
    action: 'create',
    oldValues: null,
    newValues: { amount: 45.0, status: 'completed', membershipNumber: 'HDL001' },
    createdAt: '2023-01-15T10:30:00Z',
    userId: 1,
    ipAddress: '192.168.1.100',
  },
  {
    id: 3,
    entityType: 'membershipRequest',
    entityId: 1,
    action: 'create',
    oldValues: null,
    newValues: { firstName: 'John', lastName: 'Smith', status: 'pending' },
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    userId: 101,
    ipAddress: '192.168.1.105',
  },
  {
    id: 4,
    entityType: 'member',
    entityId: 1,
    action: 'update',
    oldValues: { mobile: '07700 900001' },
    newValues: { mobile: '07700 900099' },
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    userId: 1,
    ipAddress: '192.168.1.100',
  },
  {
    id: 5,
    entityType: 'membershipType',
    entityId: 1,
    action: 'update',
    oldValues: { name: 'Individual Member' },
    newValues: { name: 'Individual' },
    createdAt: '2024-01-01T00:00:00Z',
    userId: 1,
    ipAddress: '192.168.1.100',
  },
];

// System Settings
export const systemSettings = {
  clubName: 'Hagley and District Light Car Club',
  clubEmail: 'admin@hdlcc.com',
  clubPhone: '01234 567890',
  clubAddress: {
    line1: 'Club House',
    line2: '123 Main Street',
    town: 'London',
    county: 'Greater London',
    postcode: 'SW1A 1AA',
  },
  renewalReminderDays: [60, 30, 14, 7],
  gracePeriodDays: 30,
  proRataEnabled: true,
  autoApprovalEnabled: false,
  emailFrom: 'noreply@hdlcc.com',
  emailReplyTo: 'membership@hdlcc.com',
  stripePublishableKey: 'pk_test_...',
  sendgridApiKey: 'SG...',
};

// Statistics for Dashboard
export const statistics = {
  totalMembers: 27,
  activeMembers: 26,
  pendingApprovals: 5,
  expiredMembers: 1,
  revenueThisMonth: 900.0, // December revenue (12 members × ~£75 avg)
  revenueLastMonth: 675.0, // November revenue (9 members × £75 avg)
  revenueThisYear: 9150.0, // Total for all 12 months
  newMembersThisMonth: 12,
  newMembersLastMonth: 9,
  renewalsThisMonth: 24,
  expiringWithin30Days: 2,
  expiringWithin60Days: 5,
  expiringWithin90Days: 8,
};

// Monthly Revenue Data (for charts)
// Based on average membership cost of £75
export const monthlyRevenue = [
  { month: 'Jan', revenue: 600, members: 8 },
  { month: 'Feb', revenue: 750, members: 10 },
  { month: 'Mar', revenue: 525, members: 7 },
  { month: 'Apr', revenue: 825, members: 11 },
  { month: 'May', revenue: 675, members: 9 },
  { month: 'Jun', revenue: 975, members: 13 },
  { month: 'Jul', revenue: 750, members: 10 },
  { month: 'Aug', revenue: 600, members: 8 },
  { month: 'Sep', revenue: 1050, members: 14 },
  { month: 'Oct', revenue: 825, members: 11 },
  { month: 'Nov', revenue: 675, members: 9 },
  { month: 'Dec', revenue: 900, members: 12 },
];

// Membership Type Distribution
export const membershipTypeDistribution = [
  { type: 'Individual', count: 21, percentage: 77.8 },
  { type: 'Joint', count: 4, percentage: 14.8 },
  { type: 'Youth', count: 2, percentage: 7.4 },
];

// Recent Activity (for dashboard)
export const recentActivity = [
  {
    id: 1,
    type: 'payment',
    memberName: 'Robert Wilson',
    description: 'Payment received for 2025 renewal',
    amount: 48.0,
    timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
  },
  {
    id: 2,
    type: 'new_member',
    memberName: 'John Smith',
    description: 'New membership application submitted',
    amount: null,
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 3,
    type: 'renewal',
    memberName: 'Alice Cooper',
    description: 'Membership renewed for 2025',
    amount: 98.0,
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 4,
    type: 'email_sent',
    memberName: 'Peter Morgan',
    description: 'Renewal reminder email sent',
    amount: null,
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 5,
    type: 'profile_update',
    memberName: 'Thomas Harris',
    description: 'Updated contact information',
    amount: null,
    timestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

// Helper function to get membership type by ID
export function getMembershipTypeById(id) {
  return membershipTypes.find(type => type.id === id);
}

// Helper function to get address by ID
export function getAddressById(id) {
  return addresses.find(address => address.id === id);
}

// Helper function to get current price for membership type
export function getCurrentPrice(membershipTypeId) {
  const currentYear = new Date().getFullYear();
  const price = yearlyPrices.find(
    p => p.membershipTypeId === membershipTypeId && p.year === currentYear
  );
  return price ? price.basePrice : 0;
}

// Helper function to calculate pro-rata fee
export function calculateProRataFee(membershipTypeId, joinDate) {
  const basePrice = getCurrentPrice(membershipTypeId);
  const today = new Date(joinDate);
  const yearEnd = new Date(today.getFullYear(), 11, 31);
  const daysRemaining = Math.ceil((yearEnd - today) / (1000 * 60 * 60 * 24));
  const totalDays = 365;
  return (basePrice * daysRemaining) / totalDays;
}
